/** Serie de actividad del panel: misma población, ventana y plataforma. */

export type ActivityWindow = 'active_users' | 'weekly_active_users' | 'monthly_active_users';

export type ActivityPlatform = 'all' | 'android' | 'ios' | 'other';

export type ActivitySeriesMetricId =
    | ActivityWindow
    | `${ActivityWindow}_android`
    | `${ActivityWindow}_ios`
    | `${ActivityWindow}_other`;

export const ACTIVITY_PLATFORM_OPTIONS: { value: ActivityPlatform; label: string }[] = [
    { value: 'all', label: 'Total' },
    { value: 'android', label: 'Android' },
    { value: 'ios', label: 'iOS' },
    { value: 'other', label: 'Otros' },
];

const WINDOW_SENTENCE: Record<ActivityWindow, string> = {
    active_users: 'Cuenta ese día.',
    weekly_active_users: 'Ventana de 7 días terminada ese día.',
    monthly_active_users: 'Ventana de 30 días terminada ese día.',
};

const PLATFORM_SENTENCE: Record<ActivityPlatform, string> = {
    all: 'Total: Android, iOS y el resto (web y escritorio). Quien usa dos plataformas el mismo día cuenta en cada una y una sola vez en el total.',
    android: 'Solo Android. Play Console cuenta cualquier apertura de la app Android, en hora del Pacífico, también sin sesión iniciada.',
    ios: 'Solo iOS.',
    other: 'Web, escritorio y eventos sin plataforma.',
};

export function isActivityWindow(metric: string): metric is ActivityWindow {
    return metric === 'active_users'
        || metric === 'weekly_active_users'
        || metric === 'monthly_active_users';
}

export function activitySeriesMetric(
    window: ActivityWindow,
    platform: ActivityPlatform,
): ActivitySeriesMetricId {
    if (platform === 'all') return window;
    return `${window}_${platform}`;
}

export function activityMetricHelp(window: ActivityWindow, platform: ActivityPlatform): string {
    return [
        'Usuarios con sesión iniciada y al menos un session_start.',
        WINDOW_SENTENCE[window],
        'El día va de 00:00 a 24:00, hora de Madrid; la serie termina en ayer.',
        PLATFORM_SENTENCE[platform],
    ].join(' ');
}
